module.exports = __webpack_public_path__ + "img/user-messages.f103b404.svg";